<template>
  <div>
    <div class="row">
      <div v-if="!appointmentWeek.IsBlocked" class="col-md-12 col-sm-12 col-xs-12 calendar__weeks__container" v-for="(appointmentWeek,index) in appointmentWeekSlots" v-bind:key="index">
        <div class="row">
          <div v-show="!appointmentWeek.IsBlocked" class="col-md-12 col-sm-12 col-xs-12 calendar-weeks ">
            <span v-if="appointmentWeek.WeekNumber==1">This Week </span>
            <span v-if="appointmentWeek.WeekNumber==2">Next Week</span>
            <span v-if="appointmentWeek.WeekNumber>2"> {{getDate(appointmentWeek.Min)}} - {{getDate(appointmentWeek.Max)}}
            </span>
          </div>
        </div>
        <div class="row" v-show="!appointmentWeek.IsBlocked">
          <div @click="dateSelected(apointmentDayUnit)" v-if="apointmentDayUnit.AppointmentTimeSlots.length>0" v-for="(apointmentDayUnit,counter) in appointmentWeek.AppointmentDayUnits" v-bind:key="counter" :class="{'active col-md-12 col-xs-12 transform-active':(selectedAppointmentDay==apointmentDayUnit),'col-md-2 col-xs-3':(selectedAppointmentDay!=apointmentDayUnit)}" class="c-appointment-slots__day text-center transform ">
            <span class="c-appointment-slots__day__span"> {{getDate(apointmentDayUnit.Date)}}</span>
            <div class="c-appointment-slots__time__container" v-if="selectedAppointmentDay==apointmentDayUnit">
              <div v-on:click.stop="appointmentTimeSelected(appointmentTime)" :class="{'col-md-2 col-xs-4': !debug,'col-md-12 col-xs-4':debug}" class="col-xs-4 c-appointment-slots__Time" v-for="(appointmentTime,timecounter) in apointmentDayUnit.AppointmentTimeSlots" v-bind:key="timecounter">
                <span :class="{'active':appointmentTime==selectedAppointmentDateTime}">{{getTime(appointmentTime.DateTime)}}</span>
                <span v-if="debug" v-for="(resources,doctorCounter) in appointmentTime.Resources" v-bind:key="doctorCounter">
                  {{resources.FullName}}
                </span>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row text-center" style="padding-top:30px;">
      <div class="loader__container" v-if="showCalendarLoading">
        <div class="loader"></div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 ">
        <button class="btn btn__primary__cta " :disabled="showCalendarLoading" @click="showMoreDates()">
          Show more weeks
        </button>
      </div>
    </div>
    <div class="row" style="padding-top:30px;padding-bottom:60px;">
      <div class="col-md-6 col-sm-6 col-xs-6">
        <button class="btn btn__secondary pull-left" @click="goBack()">
          Previous
        </button>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6">
        <button class="btn btn__primary pull-right" v-if="selectedAppointmentDateTime.DateTime!=null" @click="moveToNextPage()">
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'AppointmentCalendar',
  computed: {
    ...mapGetters({
      appointmentWeekSlots: 'appointmentWeekSlots',
      selectedAppointmentDay: 'selectedAppointmentDay',
      selectedAppointmentDateTime: 'selectedAppointmentDateTime',
      showCalendarLoading: 'showCalendarLoading',
      checkIfCalendarValidState: 'checkIfCalendarValidState',
      debug: 'debug'
    })
  },
  created() {
    if (!this.checkIfCalendarValidState) {
      this.$router.replace({ name: 'Practices' })
    }
    this.$store.dispatch('SetPageNumber', 5);
  },
  data() {
    return {
      canNavigateToPreviousMonth: false
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'PetServices' })
      this.$store.dispatch('ResetDate');
    },
    moveToNextPage() {
      this.$router.push({ name: 'ConfirmationPrompt' })
    },
    showMoreDates() {
      this.$store.dispatch('IncrementSlotPageNumber');
      this.$store.dispatch('GetPracticeAvailableSlots');
    },
    getDate(time) {
      return moment.parseZone(time).format('MMM DD');
    },
    getTime(time) {
      return moment.parseZone(time).format('hh:mm A');
    },
    dateSelected(apointmentDayUnit) {
      if (apointmentDayUnit == this.selectedAppointmentDay) {
        this.$store.dispatch('SetAppointmentDay', {});
      }
      else {
        this.$store.dispatch('SetAppointmentDay', apointmentDayUnit);
      }
    },
    appointmentTimeSelected(appointmentTime) {
      this.$store.dispatch('SetAppointmentDateTime', appointmentTime);
      this.$router.push({ name: 'ConfirmationPrompt' })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AppointmentCalendar.vue